<template>
  <img
    :src="mastheadSrc"
    :alt="theSiteName"
    class="masthead"
    :class="`masthead--${$site.prefix}`"
  >
</template>

<script>
export default {
  name: 'SiteMasthead',
  props: {
    siteName: {
      type: String,
      default: '',
    },
  },
  computed: {
    theSiteName() {
      return this.siteName || this.$site.name;
    },
    cleanedSiteName() {
      return this.theSiteName.split('.')[0].toLowerCase();
    },
    mastheadSrc() {
      return `/common/logo/masthead/${this.cleanedSiteName}_2025.svg`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_masthead';
</style>
